import React from "react";
import "./PrivacyPolicy.css"
import Footer from "../../Components/Footer/Footer";
import Scrolling from "../../Components/Scrolling/Scrolling";


const PrivacyPolicy = () => {
  return (
    // <div>
    <>
      <div className="privacy_policy_outer">
        <h1>Privacy Policy</h1>
        <div className="privacy_policy_content">
          <div className="privacy_policy_layer1">
            <p className="para">
              Oraddo is committed to safeguarding your privacy. This Privacy
              Policy outlines how we collect, use, and protect your personal
              information.
            </p>
          </div>
          <div className="privacy_policy_layer2">
            <h2> Information We Collect</h2>
            <h3>Personal Information</h3>
            <p className="para">Name, email address, contact details, and payment information.</p>
            <h3>Usage Data</h3>
            <p className="para">Browser type, IP address, and activity logs.</p>
            <h3>Cookies</h3>
            <p className="para">
              Small data files stored on your device to enhance user experience.
            </p>
          </div>
          <div className="privacy_policy_layer3">
            <h2>How We Use Your Information</h2>
            <ul>
              <li className="list_items">To provide and improve our services.</li>
              <li className="list_items">To communicate updates, promotions, and support messages.</li>
              <li className="list_items">To analyze usage trends and enhance platform functionality.</li>
            </ul>
          </div>
          <div className="privacy_policy_layer4">
            <h2> Data Sharing and Third Parties</h2>
            <ul>
              <li className="list_items">We do not sell your data to third parties.</li>
              <li className="list_items">
                We may share information with trusted partners for operational
                purposes.
              </li>
              <li className="list_items">
                Compliance with legal obligations may require us to disclose
                certain information.
              </li>
            </ul>
          </div>
          <div className="privacy_policy_layer5">
            <h2>Data Security</h2>
            <p className="para">
              We implement encryption, firewalls, and access controls to secure
              your data. However, no method of transmission is entirely secure.
            </p>
          </div>
          <div className="privacy_policy_layer6">
            <h2> User Rights</h2>
            <ul>
              <li className="list_items">Access your personal information.</li>
              <li className="list_items">Request correction or deletion of your data.</li>
              <li className="list_items">Opt-out of non-essential communications.</li>
            </ul>
          </div>
          <div className="privacy_policy_layer7">
            <h2>Retention Period</h2>
            <p className="para">
              {" "}
              We retain your information as long as necessary for operational and
              legal purposes.
            </p>
          </div>
          <div className="privacy_policy_layer8">
            <h2>Third-Party Links</h2>
            <p className="para">
              Our platform may contain links to third-party sites. We are not
              responsible for their privacy practices.
            </p>
          </div>
          <div className="privacy_policy_layer9">
            <h2> Updates to Privacy Policy</h2>
            <p className="para">
              Changes to this policy will be communicated via email or platform
              notifications.
            </p>
          </div>
          <div className="privacy_policy_adress">
            <h2>Contact Us</h2>
            <p className="para">
              For privacy-related queries, please contact us at:
              <ul>
                <li> Oraddo Technologies Hitech City Road,</li>
                <li> Khanamet, beside Yashoda Hospital,</li>
                <li>opposite Bharat Petrol Bunk,HITEC City,</li>
                <li>Hyderabad, Telangana 500084</li>
                <li><strong>Email:</strong> support@oraddo.com</li>
              </ul>



            </p>
          </div>
        </div>
      </div>
      <div className="privacy_footer">
        <Footer />
        <Scrolling />
</div>
      </>

      );
};

      export default PrivacyPolicy;
